import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./index.css";
import Landing from "./routes/Landing";
import Build from "./routes/Build";
import Stage from "./routes/Stage";
import TeammatePage from "./routes/TeammatePage";
import Reimagine from "./routes/Reimagine";
import BusinessPage from "./routes/BusinessPage";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/build" element={<Build />} />
        <Route path="/reimagine" element={<Reimagine />} />
        <Route path="/stage" element={<Stage />} />
        <Route path="/t/:id" element={<TeammatePage />} />
        <Route path="/b/:id" element={<BusinessPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
